/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { AccountMenuContentContainerEntrypointProps } from './ui/profile-menu/AccountMenuContentContainer.entrypoint.types.tsx';
import parameters from './ui/profile-menu/__generated__/AccountMenuContentContainerQuery$parameters';
import type { AccountMenuContentContainerQuery } from './ui/profile-menu/__generated__/AccountMenuContentContainerQuery.graphql';

type Queries = { AccountMenuContentContainerQuery: AccountMenuContentContainerQuery };

type Nav4ProfileMenuEntryPointComponent = EntryPointComponent<
	Queries,
	{},
	AccountMenuContentContainerEntrypointProps,
	{}
>;

export const Nav4ProfileMenuEntryPoint: EntryPoint<
	Nav4ProfileMenuEntryPointComponent,
	{
		atlassianAccountId?: string;
		jiraOnboardingHubGateEnabled?: boolean;
	}
> = createEntryPoint({
	root: JSResourceForInteraction<Nav4ProfileMenuEntryPointComponent>(
		/* webpackChunkName: "atlassian-navigation-profile-menu" */ './ui/profile-menu/AccountMenuContentContainer.tsx',
	),
	getPreloadProps: ({
		atlassianAccountId,
		jiraOnboardingHubGateEnabled,
	}: {
		atlassianAccountId?: string;
		jiraOnboardingHubGateEnabled?: boolean;
	}) => ({
		queries: {
			AccountMenuContentContainerQuery: {
				parameters,
				variables: {
					atlassianAccountId: atlassianAccountId ?? '',
					jiraOnboardingHubGateEnabled: jiraOnboardingHubGateEnabled ?? false,
				},
			},
		},
	}),
});
